export default "__VITE_ASSET__QPGFNfOC__"